import * as React from 'react';
import { ThemeContext } from './ThemeContext';

export function useTheme() {
  const context = React.useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeContext');
  }

  return context;
}
